import { useContext, useRef, useState } from "react";
import {Modal, Button} from "react-bootstrap";
import AuthContext from "../context/authContext";
import useIdleTimeout from "../hooks/useIdleTimeout";
import { useNavigate, useLocation } from "react-router-dom";

import { PrintScaling, PrintPageSize, PrintOrientation  } from "https://tabback.ccbh.com/javascripts/api/tableau.embedding.3.latest.js";
import { LuScaling, LuCopy, LuCopyPlus, LuFile, LuFileStack } from 'react-icons/lu';
import { postUserStat } from '../helpers/statHelpers';


import './exportDialog.css';

const ExportOutDialog = ({isOpen, onClose, userName}) => {
    let navigate = useNavigate();
    const dialogRef = useRef(null);
    console.log('Dialog open: ' + isOpen);
    
    const location = useLocation();
    const loginResult = location.state?.loginResult;
    const user = location.state?.loginResult.user;


    const [openModal, setOpenModal] = useState(isOpen);
        
    const handleIdle = () => {
        setOpenModal(true);
    };
  
    const handleHide = () => {

    };

    const handleOnOpenModal = () => {

    };
    
    const addStat = async(elementName, workbookName, dashbaordName, exportType=null) => {
        return await postUserStat(user.authorization, userName, "Export Dialog", elementName, workbookName, dashbaordName, exportType);
    };

    const [selectedFormatValue, setSelectedFormatValue] = useState('PDF'); // set export Format -PDF or PowerPoint
    const [exportSingle, setExportSingle] = useState(true);    // export single page - dashboard
    const [exportSingleDisabled, setExportSingleDisabled] = useState(""); // enable/disable dashboard radio
    const [exportWorkbook, setExportWorkbook] = useState(false); // export entire workbook
    const [exportWorkbookDisabled, setExportWorkbookDisabled] = useState(""); // enable/disable workbook radio

    const handleFormatChange = (event) => {
        console.log("HANDLE FORMAT CHANGE");
        setSelectedFormatValue(event.target.value);

        if(event.target.value === "PDF"){
            setExportSingleDisabled("");
            setExportWorkbookDisabled("");
            setExportSingle(true);
            setExportWorkbook(false);
        }else{
            setExportSingleDisabled("disabled");
            setExportWorkbookDisabled("disabled");
            setExportSingle(false);
            setExportWorkbook(true);
        }
        console.log('Format: ' + event.target.value);
        console.log("dashboard radio enable: " + exportSingleDisabled);
        console.log("workbook radio enable: " + exportWorkbookDisabled);

    };

    // handle change or workbook or dashbaord radio button select
    const handleExportChange = (event) => {
        console.log("HANDLE EXPORT CHANGE");
        if(event.target.value === "dashboard"){
            setExportSingle(true);
            setExportWorkbook(false);
        }else{
            setExportSingle(false);
            setExportWorkbook(true);
        }
        console.log('Format: ' + event.target.value);
        console.log("dashboard radio enable: " + exportSingleDisabled);
        console.log("workbook radio enable: " + exportWorkbookDisabled);
    };

    const handleCancel = (event) => {
        setOpenModal(false);
    };

    // Print the Worknook or Dashboard
    const handleExport = async(event) => {
        event.preventDefault();

        let viz = document.getElementById('tableauViz');
        const workbook = viz.workbook;
        const activeSheet = workbook.activeSheet;
        const publishedSheetNames = workbook.publishedSheetsInfo.map((publishedSheetInfo) => publishedSheetInfo.name);

        onClose(event);
        if(selectedFormatValue == 'PDF'){
            const exportOptions = {
                scaling: PrintScaling.Automatic,
                pageSize: PrintPageSize.Letter,
                orientation: PrintOrientation.Landscape
            };

            if(exportWorkbook){
                //activeSheet.workbook.name  Entire Workbook 
                await viz.exportPDFAsync(publishedSheetNames, exportOptions).then(
                    addStat('Export PDF: Entire Workbook', activeSheet.workbook.name, "all", 'PDF')
                );
            }else{
                //activeSheet.workbook.name  Single Dashboard
                var detail = 'Workbook: ' + activeSheet.workbook.name + ' Dashboard: ' + activeSheet.name;
                await viz.exportPDFAsync([activeSheet.name], exportOptions).then(
                    addStat('Export PDF: Single Dashboard', activeSheet.workbook.name, activeSheet.name, 'PDF')
                );
            }
        }else{
            await viz.exportPowerPointAsync(publishedSheetNames).then(
                addStat('Export PowerPoint', activeSheet.workbook.name, "all", 'PowerPoint')
            );
        }
    };

    const cutomStlyles = {
        content:{postion:'fixed'},
        overlay: {zIndex: 9999}
    };
    
    return(
        <>
        <Modal show={openModal} onHide={handleHide}  style={cutomStlyles} onShow={handleOnOpenModal}> 
            <Modal.Header >
                <Modal.Title>Export Workbook or Dashboard</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <select value={selectedFormatValue} onChange={handleFormatChange}>
                    <option value="PDF">PDF</option>
                    <option value="PowerPoint">PowerPoint</option>
                </select>
                <label>Export Format</label>
                <br /><br />
                <div>
                    <h6 id="div-title"> Export </h6>
                    <div className="bordered">
                    <label className="exportDialogLabel">
                        <input className="exportDialogInput" type="radio" checked={exportSingle} disabled={exportSingleDisabled} value="dashboard" name="export_dashboard" onChange={handleExportChange}/>
                         Single Dashboard
                    </label>
                    <label className="exportDialogLabel"> 
                        <input className="exportDialogInput" type="radio" checked={exportWorkbook} disabled={exportWorkbookDisabled} value="workbook" name="export_workbook" onChange={handleExportChange}/>
                        Entire Workbook
                    </label>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="ModalFooter">
                <Button variant="secondary" onClick={onClose}>
                   Cancel 
                </Button>
                <Button variant="primary" onClick={handleExport}>
                    Export
                </Button>
            </Modal.Footer>
        </Modal>
        </>
    );
}

export default ExportOutDialog;